module.exports = __webpack_public_path__ + "static/media/spares2.6529acbc.jpg";